<template>
  <div class="a7-painel">
    <component
      :is="menuComponent"
      :itens="itens"
      :filtrosAtivos="filtros"
      @filtrou="setFiltros"
      @agrupou="setAgrupamento"/>
  </div>
</template>

<script>
import A7PainelMobile from './A7PainelMobile'
import A7PainelDesktop from './A7PainelDesktop'
import MedicaoIndicadorRestResource from './MedicaoIndicadorRestResource'
import {FilterUtilities} from 'guaxinim-web'
export default {
  name: "a7-painel",
  components: {
    A7PainelMobile,
    A7PainelDesktop
  },
  data: () => ({
    itens: [],
    agrupamento: null,
    filtros: null
  }),
  computed: {
    menuComponent() {
      return ['xs', 'sm', 'md'].includes(this.$mq) ?'a7-painel-mobile': 'a7-painel-desktop'
    }
  },
  methods: {
    setAgrupamento(value) {
      this.agrupamento = [...value]
      this.heavyFetch()
    },
    setFiltros(value) {
      this.filtros = {...value}
      this.heavyFetch()
    },
    setItens(itens) {
      this.itens = (itens) ? [itens] : null
    },
    fetch() {
      const vm = this
      if (vm.agrupamento === null || vm.filtros === null)
        return
      const filterParamsString =
        FilterUtilities.createFilterParamsString(vm.filtros)

      return MedicaoIndicadorRestResource
        .getPainelIndicadorDTO(vm.agrupamento, filterParamsString)
        .then(dados => this.setItens(dados))
        .catch((err) => this.$gw.defaultExceptionHandler.handleUnknownException(err, this))
    },
    heavyFetch() {
      this.heavyTask(this.fetch())
    }
  }
}
</script>

<style lang="scss" scoped>
  .a7-painel {
    position: relative;
    height: 100%;
    padding: 0px;
    margin: 0px;
  }
</style>
